import generateCreateDefaultState from './generateCreateDefaultState';
import createJobDefaultReducer from './createJobDefaultReducer';

export default (
  state = generateCreateDefaultState('CHEQUE_DEPOSIT'),
  action
) => {
  return createJobDefaultReducer('CHEQUE_DEPOSIT', action, state);
};
